export const environment = {
  production: true,
  development: false,
  isDebugMode: false,
  helpUrl: 'https://texconnect.freshdesk.com/',
  useTexStateWithDynamicTemplates: true
};
